import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// TOPのイベントスライダー（ピックアップ／開催直前）。
export default class extends Controller {
  connect() {
    this.initializeSwiper();
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = undefined;
    }
  }

  initializeSwiper() {
    const el = this.element.querySelector(".js-top-event-slider") || this.element;
    const slidesCount = el.querySelectorAll(".swiper-slide").length;
    // limitを外し、画面幅に対して十分な複製を確保する。
    const loopedSlides = slidesCount * 6;

    this.swiper = new Swiper(el, {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      lazy: true,
      loop: slidesCount > 1,
      loopedSlides,
      loopedSlidesLimit: false,
      spaceBetween: 24,
      speed: 400,
      slidesPerView: "auto",
      centeredSlides: true,
      breakpoints: {
        768: {
          spaceBetween: 23,
          centeredSlides: true,
        },
      },
      pagination: {
        el: el.querySelector(".js-top-event-slider-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".js-top-event-slider-next"),
        prevEl: el.querySelector(".js-top-event-slider-prev"),
      },
      keyboard: {
        enabled: true,
      },
    });
  }

  // 再生/停止ボタン
  sliderstop(e) {
    if ($(e.currentTarget).hasClass("is-pause")) {
      this.swiper.autoplay.start();
      $(e.currentTarget).removeClass("is-pause");
      $(e.currentTarget).text("停止する");
    } else {
      this.swiper.autoplay.stop();
      $(e.currentTarget).addClass("is-pause");
      $(e.currentTarget).text("再生する");
    }
  }
}
